export default function employeeReducer(state, action) {
  
  switch (action.type) {
    case 'GET_ALL_EMPLOYEES':
      return {
        ...state,
        employees: action.payload,
        loading: false,
        totalPages: action.totalPages,
      }
    case 'ADD_EMPLOYEE':
      return {
        ...state,
        employees: [action.payload, ...state.employees],
      }
    case 'EDIT_EMPLOYEE':
      const updatedEmployee = action.payload

      const updatedEmployees = state.employees.map((employee) => {
        if (employee._id === updatedEmployee._id) {
          return updatedEmployee
        }
        return employee
      })

      return {
        ...state,
        employees: updatedEmployees,
      }
    case 'REMOVE_EMPLOYEE':
      return {
        ...state,
        employees: state.employees.filter((employee) => employee._id !== action.payload),
      }
    default:
      return state
  }
}
